module.exports = __webpack_public_path__ + "static/media/MtSutro.3b32765f.md";